import React, { useEffect } from 'react';

interface VGWortPixelProps {
  pixelUrl?: string;
  title: string;
}

const VGWortPixel: React.FC<VGWortPixelProps> = ({ pixelUrl, title }) => {
  useEffect(() => {
    if (!pixelUrl) return;

    // Whitelist of allowed VG Wort domains
    const allowedDomains = [
      'ssl-vg03.met.vgwort.de',
      'ssl-vg02.met.vgwort.de',
      'ssl-vg01.met.vgwort.de'
    ];

    try {
      const url = new URL(pixelUrl);
      
      // Validate that the domain is in our whitelist
      if (!allowedDomains.includes(url.hostname)) {
        console.error('VG Wort pixel domain not whitelisted:', url.hostname);
        return;
      }

      // Validate protocol is HTTPS
      if (url.protocol !== 'https:') {
        console.error('VG Wort pixel must use HTTPS');
        return;
      }

      // Create and append VG Wort tracking pixel
      const img = document.createElement('img');
      img.width = 1;
      img.height = 1;
      img.alt = '';
      img.style.position = 'absolute';
      img.style.left = '-9999px';
      img.setAttribute('aria-hidden', 'true');
      
      // Sanitize and add title parameter
      if (title) {
        const sanitizedTitle = title.replace(/[<>"'&]/g, ''); // Remove potential HTML/JS chars
        url.searchParams.set('title', encodeURIComponent(sanitizedTitle));
      }
      
      img.src = url.toString();
      document.body.appendChild(img);
      
      // Cleanup function to remove pixel when component unmounts
      return () => {
        if (document.body.contains(img)) {
          document.body.removeChild(img);
        }
      };
    } catch (error) {
      console.error('Invalid VG Wort pixel URL:', error);
      return;
    }
  }, [pixelUrl, title]);

  // VG Wort pixel is invisible, so we don't render anything
  return null;
};

export default VGWortPixel;